import type * as React from 'react';

import * as styles from './styles';
import ButtonBase, { type ButtonBaseProps } from '@material-ui/core/ButtonBase';
import { withStyles } from '@material-ui/core/styles';

import { BackToTopIcon } from '../../icons';

const StyledButton = withStyles({
  root: {
    opacity: 0.3,
    transition: 'opacity 0.2s ease-in-out',
    '&:hover': {
      opacity: 0.5,
    },
  },
})(ButtonBase);

export const BackToTopButton: React.FC<ButtonBaseProps> = (props) => {
  return (
    <StyledButton disableRipple {...props}>
      <BackToTopIcon className={styles.icon} />
    </StyledButton>
  );
};
